export default __webpack_public_path__ + "static/media/8.ebc3a3e3.jpeg";